import {EventEmitter, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs/BehaviorSubject';

@Injectable()
export class DataService {
  public selectedTimeLine = new BehaviorSubject<any>('');
  currentTimeline = this.selectedTimeLine.asObservable();
  public selectedVisit = new BehaviorSubject<any>('');
  currentVisit = this.selectedVisit.asObservable();
  //
  // public selectedVisitId = new BehaviorSubject<any>('');
  // }
  timlineClickedId = new EventEmitter<any>();

  // currentVisitId = this.selectedVisitId.asObservable();
  constructor() {
  }

  changeMessage(id: any) {
    console.log('id in data service::', id);
    this.selectedTimeLine.next(id);
    // console.log('timeline');
    // console.log(id);
  }

  //
  // changeVisitId(id: any) {
  //   this.selectedVisitId.next(id);
  //   // console.log("selectedVisit id");
  //   // console.log(id);

  changeVisit(id: any) {
    this.selectedVisit.next(id);
    // console.log('selectedVisit');
    // console.log(id);
  }
  /*  private subject = new Subject<any>();

    sendData(message: string) {
      this.subject.next(message);
    }

    sendTimelineId(id: any) {
      this.subject.next(id);
    }

    clearData() {
      this.subject.next();
    }

    getData(): Observable<any> {
      return this.subject.asObservable();
    }*/
}



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/patient-chart/data.service.ts